// extracted by mini-css-extract-plugin
export default {"input_title":"input_input_title__-Jq5A","input_input":"input_input_input__PFCNh","input_icon":"input_input_icon__xrp66"};